import React, { useState } from 'react';
import { galleryImages } from '../data';

export default function Gallery() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-24 md:py-32 relative" style={{ background: '#0A0A14' }}>
      <div className="grid-bg absolute inset-0 opacity-20" />
      <div
        className="orb w-80 h-80 top-20 right-0 opacity-10"
        style={{ background: 'rgba(74,144,226,0.4)', animationDelay: '-1s' }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">

        {/* Header */}
        <div className="text-center mb-12 reveal">
          <span className="section-tag">Visual Tour</span>
          <h2
            className="font-playfair font-black text-white mb-4"
            style={{ fontFamily: 'Playfair Display,serif', fontSize: 'clamp(2rem,3.5vw,3rem)' }}
          >
            Our <span style={{ color: '#C8A84B' }}>Gallery</span>
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 mb-8">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className={`gallery-item rounded-sm cursor-pointer ${
                i % 5 === 0 ? 'row-span-2' : ''
              }`}
              style={{
                height: i % 5 === 0 ? '360px' : '180px'
              }}
              onClick={() => setLightboxIndex(i)}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover rounded-sm"
              />

              <div className="overlay rounded-sm">
                <div className="text-white font-semibold text-sm">
                  {img.alt}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.95)', backdropFilter: 'blur(15px)' }}
          onClick={() => setLightboxIndex(null)}
        >
          <button
            className="absolute top-6 right-6 text-white text-3xl w-12 h-12 flex items-center justify-center rounded-full border"
            style={{ borderColor: 'rgba(255,255,255,0.2)' }}
            onClick={() => setLightboxIndex(null)}
          >
            ✕
          </button>

          {lightboxIndex > 0 && (
            <button
              className="absolute left-6 text-white text-3xl w-12 h-12 flex items-center justify-center rounded-full border"
              style={{ borderColor: 'rgba(255,255,255,0.2)' }}
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex(lightboxIndex - 1);
              }}
            >
              ‹
            </button>
          )}

          {lightboxIndex < galleryImages.length - 1 && (
            <button
              className="absolute right-6 text-white text-3xl w-12 h-12 flex items-center justify-center rounded-full border"
              style={{ borderColor: 'rgba(255,255,255,0.2)' }}
              onClick={(e) => {
                e.stopPropagation();
                setLightboxIndex(lightboxIndex + 1);
              }}
            >
              ›
            </button>
          )}

          <div className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
            <img
              src={galleryImages[lightboxIndex].src}
              alt={galleryImages[lightboxIndex].alt}
              className="w-full max-h-[80vh] object-contain rounded-sm"
            />

            <div
              className="text-center mt-4"
              style={{ color: 'rgba(212,207,197,0.5)', fontSize: '0.8rem' }}
            >
              {lightboxIndex + 1} / {galleryImages.length}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}